import { PersonalBenefit } from '@models/benefit.types';
import { User, UserResponse } from '@models/user.types';
import { createAsyncTask } from '@stores/taskStore';

import { API_BASE_URL } from './api.constants';
import { authClient } from './client.api';

export const USER_API_URLS = {
  GET_BENEFIT: `${API_BASE_URL}benefits/benefit/code`,
  GET_USER: `${API_BASE_URL}myinformation`,
  UPDATE_USER: `${API_BASE_URL}loggeduser`,
} as const;

export const userApi = {
  update: createAsyncTask('update-user-information', (payload: Partial<User>) =>
    authClient.put<void>(USER_API_URLS.UPDATE_USER, payload)
  ),

  getUser: () => authClient.get<UserResponse>(USER_API_URLS.GET_USER),

  getBenefit: (params: { type: string; partner: string }) =>
    authClient.get<PersonalBenefit>(USER_API_URLS.GET_BENEFIT, { params }),
};
